import SITE_SETTINGS from 'src/constants/whiteLabel';
import { TSelectItem } from '../components/types';
import { BRP_CLIENT } from 'src/constants/clients/brp';
import { TOBSA_CLIENT } from 'src/constants/clients/tobsa';
import {
    LEAD_FROM_DCP,
    LEAD_FROM_GO_VIRTUAL,
    LEAD_FROM_KRAQUEN,
    LEAD_FROM_INCADEA,
    LEAD_FROM_WARBOX
} from 'src/constants/lead/from';
import { TFunction } from 'src/constants/i18next';

/**
 * Maps the car types to a select item
 *
 * @param {TUserCarType} carType
 * @param {TFunction} t
 * @return {*}  {TSelectItem[]}
 */
export const mapOrigins = (t: TFunction): TSelectItem[] => {
    let origins = [
        {
            label: t('Leads.Manual'),
            value: LEAD_FROM_WARBOX,
        },
        {
            label: `${t('Leads.Automated')} (${LEAD_FROM_KRAQUEN})`,
            value: LEAD_FROM_KRAQUEN,
        },
    ];

    if (
        SITE_SETTINGS.client === BRP_CLIENT ||
        SITE_SETTINGS.client === TOBSA_CLIENT
    ) {
        origins.push({
            label: `${t('Leads.Automated')} (${LEAD_FROM_GO_VIRTUAL})`,
            value: LEAD_FROM_GO_VIRTUAL,
        });
        origins.push({
            label: `${t('Leads.Automated')} (${LEAD_FROM_INCADEA})`,
            value: LEAD_FROM_INCADEA,
        });
        origins.push({
            label: t('Leads.Bossweb'),
            value: LEAD_FROM_DCP,
        });
    }

    return origins;
};
